export default __webpack_public_path__ + "static/media/Shaka_particle_final_05.18af13a3.png";